import { useState } from "react";
import { Button, Icon } from "semantic-ui-react";

import { Can } from "components";
import { WebhooksDashboardTable } from "modules/WebhooksDashboard/components";
import { CrudWebhookModal } from "modules/WebhooksDashboard/components/CrudWebhookModal";
import { useLocationChecklistsQuery } from "modules/WebhooksDashboard/hooks";
import "modules/WebhooksDashboard/WebhooksDashboard.scss";

import type { Webhook } from "models";

export const WebhooksDashboard = () => {
  const [showCreateWebhookModal, setShowCreateWebhookModal] = useState<number | null>(null);
  const { locationChecklists, isFetching } = useLocationChecklistsQuery();

  const handleShowCreateWebhookModal = () => setShowCreateWebhookModal(-1);
  const handleCloseCreateWebhookModal = () => setShowCreateWebhookModal(null);
  const handleShowEditWebhookModal = (webhook: Webhook) => setShowCreateWebhookModal(webhook.id);

  return (
    <div className="WebhooksDashboard">
      <Can I="create" the="webhooks">
        <div className="WebhooksDashboard__toolbar">
          <Button basic icon className="add-btn" onClick={handleShowCreateWebhookModal}>
            <Icon className="plus" />
          </Button>
        </div>
      </Can>

      <WebhooksDashboardTable handleShowEditWebhookModal={handleShowEditWebhookModal} />
      <CrudWebhookModal
        isOpen={!!showCreateWebhookModal}
        webhookId={showCreateWebhookModal}
        isFetchingChecklists={isFetching}
        onClose={handleCloseCreateWebhookModal}
        locationChecklists={locationChecklists}
      />
    </div>
  );
};
